import { applyBenchmarkDataToIntensity, } from './intensity';
import { applyKpiBenchmarkToMetricValue, } from './kpi-benchmark';
/**
 * Resolves ONE prescribed metric value against whichever benchmark applies to
 * its column: an `intensity`-typed column resolves against the athlete's 1RM
 * into a weight; a KPI-mapped column (an entry for `column.metricId` exists in
 * `data.kpiBenchmarks`) resolves against the athlete's latest KPI reading;
 * every other column passes the value through unchanged.
 *
 * Intensity is checked first, and the two are mutually exclusive by
 * construction rather than by convention here: `intensity`/`sets`/`reps`
 * metrics can never be KPI-mapped (enforced server-side by
 * `assertKpiMetricsEligible`), so no tie-breaking rule is needed.
 *
 * `column.metricId` is optional only so callers that never resolve KPI columns
 * don't need to fabricate one. Passing a real metricId that turns out not to
 * be KPI-mapped is already a safe no-op inside `applyKpiBenchmarkToMetricValue`
 * (it returns the value unchanged), so omitting it changes nothing except
 * satisfying callers that genuinely have no metricId to give.
 */
export function applyBenchmark(value, column, data, profileId) {
    if (column.metricType === 'intensity') {
        // Every column typed `intensity` parses through the intensity spec, so
        // `value` is always an `Intensity` here even though this function's
        // parameter type is the broader `NumericMetric` union.
        return applyBenchmarkDataToIntensity(value, column.libraryExerciseId, data, column.benchmarkGridId, profileId);
    }
    if (column.metricId) {
        return applyKpiBenchmarkToMetricValue(value, column.metricId, data);
    }
    return value;
}
//# sourceMappingURL=benchmark.js.map